import UserApplicationsContainer from './containers/UserApplicationsContainer';
export default UserApplicationsContainer;
